/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "The project is currently in Hiatus, the ", React.createElement(_components.a, {
    href: "https://github.com/GraseHotspot/grase-www-portal/issues"
  }, "Github Issues"), " tracker is currently closed."), "\n", React.createElement(_components.p, null, React.createElement(_components.strong, null, "If you are having a problem with the Hotspot, please sign up to our ", React.createElement(_components.a, {
    href: "/support/mailing-list/",
    title: "Mailing List"
  }, "mailing list"), " and post your support request there.")), "\n", React.createElement(_components.p, null, "Due to the project being in Hiatus please report security issues to the mailing list."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
